import React from "react";
import i18n from "../../i18n";
import { useTranslation } from "react-i18next";

import fr from "../../assets/flags/fr.svg";
import en from "../../assets/flags/en.svg";

import "./Menu.css";

const Menu = ({
  scrollToHome,
  scrollToPortfolio,
  scrollToAboutMe,
  scrollToContact,
}) => {
  const { t } = useTranslation();

  return (
    <ol className="menu_content">
      <li className="menu_content_item link link--io" onClick={scrollToHome}>
        {t("nav.home")}
      </li>
      <li
        className="menu_content_item link link--dia link link--dia"
        onClick={scrollToAboutMe}
      >
        {t("nav.about")}
      </li>
      <li
        className="menu_content_item link link--thebe"
        onClick={scrollToPortfolio}
      >
        {t("nav.portfolio")}
      </li>
      <li
        className="menu_content_item link link--kale"
        onClick={scrollToContact}
      >
        {t("nav.contact")}
      </li>
      <li className="language-item" onClick={() => i18n.changeLanguage("fr")}>
        <img src={fr} className="flag" alt="flag-fr" />
      </li>
      <li className="language-item" onClick={() => i18n.changeLanguage("en")}>
        <img src={en} className="flag" alt="flag-en" />
      </li>
    </ol>
  );
};

export default Menu;
